import { jwtDecode } from 'jwt-decode';

interface TokenPayload {
    iat: number;
    exp: number;
    roles: string[];
    username: string;
}

export const decodeToken = (token: string): TokenPayload | null => {
    try {
        return jwtDecode<TokenPayload>(token);
    } catch (error) {
        console.error('Failed to decode token:', error);
        return null;
    }
};
